import { connect } from 'react-redux'
import LoginView from '../components/LoginView'
import {changePhoneNumber, changePassword, markAsAuthenticated} from '../modules/login'

const mapDispatchToProps = {
  changePhoneNumber,
  changePassword,
  markAsAuthenticated
};

const mapStateToProps = (state) => ({
  phone_number: state.phone_number,
  password: state.password
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginView)



// WEBPACK FOOTER //
// ./src/routes/Login/containers/LoginContainer.js